import {Component, Input, OnInit} from '@angular/core';
import {Location} from '@angular/common';

@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.css'],
    standalone: false
})
export class PageHeaderComponent implements OnInit {

  @Input() heading: string;
  @Input() subHeading: string;

  constructor(private _location: Location) {
  }

  ngOnInit(): void {
  }

  goBack = (): void => this._location.back();
}
